import axios from "../axios";

const api = {
  getItems({ questionnaireId, scopeCategoryKey }, accessToken) {
    const config = {
      params: { scope: scopeCategoryKey },
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${questionnaireId}/manual-emissions`, config)
      .then(({ data }) => data);
  },

  createItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/manual-emissions`, data, headers)
      .then(({ data }) => data);
  },

  updateItem({ questionnaireId, id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/manual-emissions/${id}`, data, headers)
      .then(({ data }) => data);
  },

  deleteItem({ questionnaireId, id }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/manual-emissions/${id}`, headers)
      .then(({ data }) => data);
  }
};

export default api;
